import { withFormik } from "formik";
import React, { Component } from "react";

import { GET } from "../../../../util/apiHelpers";
import LoadingPage from "../../../General/LoadingPage";
import PageCard from "../../../General/PageCard";
import EmployerLogo from "../FormContent/EmployerLogo";

import {
  buildValidationSchema,
  bundleFormContext,
  handleSubmit,
} from "../FormContent/formHelpers";
import NotFoundContent from "../FormContent/NotFoundContent";
import {
  FieldSection,
  OrganizationNameField,
  EmailField,
  PasswordField,
  AgreesToTermsField,
} from "../FormContent/RegistrationFormFields";
import RegistrationFormFooter from "../FormContent/RegistrationFormFooter";
import RFIFeaturesGraphic from "../FormContent/RFIFeaturesGraphic";
import TermsSection from "../FormContent/TermsSection";

function SolicitorGreeting({ employer }) {
  return (
    <div style={{ width: "90%", padding: "0 24px 24px 24px" }}>
      Welcome to
      {' '}
      <span className="bold">
        {employer.name}
        's
      </span>
      {' '}
      RecruitiFi agency
      portal. You are applying to be part of the Community. Please create your
      login so you can begin the application process. If accepted, you will be
      invited to work on jobs suited to your skillset.
    </div>
  );
}

class SolicitorRegistrationForm extends Component {
  state = { loaded: false, solicitedEmployer: {} };

  componentDidMount() {
    const { solicitedEmployerId, solicitedEmployerProfileId } = this.props;

    const queryParams = solicitedEmployerProfileId
      ? `?profile_id=${solicitedEmployerProfileId}`
      : "";

    GET(`/api/v3/public/organizations/${solicitedEmployerId}${queryParams}`)
      .then(({ data }) => {
        this.props.setFieldValue(
          "solicited_employer_profile_id",
          data.data.attributes.id
        );
        const solicitedEmployer = data.data.attributes;
        this.setState({ loaded: true, solicitedEmployer });
      })
      .catch(() => {
        this.setState({ loadError: true, loaded: true });
      });
  }

  renderContent() {
    const { solicitedEmployer, loadError } = this.state;
    const formContextProps = bundleFormContext(this.props);

    const renderForm = () => (
      <>
        <RFIFeaturesGraphic />
        <SolicitorGreeting employer={solicitedEmployer} />
        <TermsSection />
        <FieldSection>
          {[
            OrganizationNameField,
            EmailField,
            PasswordField,
            AgreesToTermsField,
          ].map((fieldKlass) => React.createElement(fieldKlass, formContextProps))}
        </FieldSection>
      </>
    );

    return (
      <PageCard
        title="Agency Application"
        withImageCardHeader
        avatar={<EmployerLogo logoURL={solicitedEmployer.avatar_url} />}
        footerVisible={!loadError}
        contentPadding={24}
        footer={<RegistrationFormFooter {...formContextProps} />}
      >
        {loadError ? <NotFoundContent /> : renderForm()}
      </PageCard>
    );
  }

  render() {
    const { loaded } = this.state;
    return loaded ? this.renderContent() : <LoadingPage />;
  }
}

const SolicitorRegistrationFormWithFormik = withFormik({
  handleSubmit,
  mapPropsToValues: (props) => ({
    organization_name: "",
    email: "",
    password: "",
    agrees_to_terms: false,
    solicited_employer_profile_id: props.solicitedEmployerProfileId,
  }),
  validationSchema: buildValidationSchema([
    "organization_name",
    "email",
    "password",
    "agrees_to_terms",
  ]),
})(SolicitorRegistrationForm);

export default SolicitorRegistrationFormWithFormik;
